import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

interface RelatedCategory {
  id: string;
  title: string;
  description: string;
  image: string;
  link: string;
}

interface RelatedCategoriesProps {
  currentCategory: string;
}

const allCategories: RelatedCategory[] = [
  {
    id: 'transformers',
    title: 'Силовые трансформаторы',
    description: 'Трансформаторы ТСЛ, ТСЗ и ТМГ для промышленных и гражданских объектов',
    image: '/images/transformers/Foto3.jpg',
    link: '/catalog/transformers'
  },
  {
    id: 'ktp',
    title: 'Трансформаторные подстанции',
    description: 'КТП, КТПН, КТПНУ и БКТП для распределения электроэнергии',
    image: '/images/transformers/ktpn.jpg',
    link: '/catalog/ktp'
  },
  {
    id: 'switchgear',
    title: 'Щитовое оборудование',
    description: 'Распределительные щиты, щиты учета, ВРУ, шкафы управления',
    image: '/images/transformers/04VRU.webp',
    link: '/catalog/switchgear'
  },
  {
    id: 'kso',
    title: 'Камеры КСО',
    description: 'Камеры сборные одностороннего обслуживания 6-10 кВ',
    image: '/images/transformers/kso.webp',
    link: '/catalog/kso'
  },
  {
    id: 'cable',
    title: 'Силовые кабели',
    description: 'Медные и алюминиевые кабели различных марок и сечений',
    image: '/images/transformers/kable.JPG',
    link: '/catalog/cable'
  }
];

const RelatedCategories: React.FC<RelatedCategoriesProps> = ({ currentCategory }) => {
  const relatedCategories = allCategories.filter(cat => cat.id !== currentCategory);

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-16">
      <h2 className="text-xl font-semibold mb-6">Смежное оборудование</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {relatedCategories.map(category => (
          <Link 
            key={category.id}
            to={category.link}
            className="group bg-white rounded-lg border border-gray-100 overflow-hidden hover:shadow-md transition-all duration-300"
          >
            <div className="aspect-[4/3] overflow-hidden">
              <img 
                src={category.image}
                alt={category.title}
                className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-4">
              <h3 className="text-sm font-semibold mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                {category.title}
              </h3>
              <p className="text-xs text-gray-600 line-clamp-2 mb-3">
                {category.description}
              </p>
              <div className="inline-flex items-center text-xs font-medium text-primary-600 group-hover:text-primary-700">
                Подробнее
                <ArrowRight className="ml-1 w-3 h-3 transition-transform group-hover:translate-x-1" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedCategories;